import type { Comp } from "kaplay";
import { config } from "../config";
import { emit } from "../core/events";
import { k } from "../core/kaplay";
import { hash, mulberry32 } from "../core/rng";
import type { RunState } from "../core/runState";
import type { Rider } from "./rider";
import type { TakeoffComp } from "./takeoff";

const ROUGH_HOPS_PER_S = 0.8;
const ROUGH_HOP_SPEED = 1.5;

export function hops(run: RunState): Comp {
    const air = config.tricks.air;
    const rng = mulberry32(hash(run.seed, 0x686f70, 0));
    let cooldown = 0;

    return {
        id: "hops",
        require: ["rider", "takeoff"],
        update(this: Rider & TakeoffComp) {
            cooldown = Math.max(0, cooldown - k.dt());
            if (this.state !== "riding" || this.rampAhead()) return;

            if (this.intent.jump && cooldown === 0) {
                this.launch(air.bunnyhopVz);
                cooldown = air.bunnyhopCooldownS;
                emit("jump", { source: "bunnyhop", strength: air.bunnyhopVz, pop: false });
                return;
            }

            const { rough } = config.zones.surfaces[run.surface];
            if (rough > 0 && this.motion.speed > 1 && rng() < rough * ROUGH_HOPS_PER_S * k.dt()) {
                this.launch(ROUGH_HOP_SPEED);
            }
        },
    };
}
